<template>
  <div v-if="contents.status">
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl my-5">
      <!--begin::Hero card-->
      <div class="card mb-12 shadow-sm">
        <!--begin::Hero body-->
        <div class="card-body flex-column p-5 mb-5">
          <!--begin::Hero content-->
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center h-lg-300px p-5 p-lg-15 overlay-wrapper gap-10">
            <!--begin::Wrapper-->
            <div class="d-flex flex-column align-items-start justift-content-center flex-equal me-5 order-1 order-md-0">
              <!--begin::Title-->
              <h1 class="fw-bolder fs-4 fs-lg-1 text-gray-800 mb-5 mb-lg-5">
                {{ contents.data.page.locale.title }}
              </h1>
              <!--end::Title-->
              <!--begin::Input group-->
              <div class="position-relative w-100 mb-5 mb-lg-10">
                <span class="text-gray-600 fs-6">{{
                  contents.data.page.locale.subTitle
                }}</span>
              </div>
              <!--end::Input group-->
              <!--begin::Action-->
              <div class="d-flex flex-column flex-lg-row justify-content-center align-items-center w-100 gap-1">
                <a v-if="$store.state.projectUUID == '9c54439ca9c54d1091ba9476fdb6d6f0'" href="#"
                  class="col-12 col-lg-4 py-5 px-4 btn btn-primary fw-bolder fs-5"
                  @click="setModalConfigs('hliLessons')">
                  <i class="me-2 fs-4" :class="`${contents.data.page.setting.buttonIcon}`"></i>
                  Add Lessons
                </a>
                <a v-if="$store.state.projectUUID == '9c54439ca9c54d1091ba9476fdb6d6f0'" href="#"
                  class="col-12 col-lg-4 p-5 btn btn-primary fw-bolder fs-5" @click="setModalConfigs('hliUnits')"><i
                    class="me-2 fs-4" :class="`${contents.data.page.setting.buttonIcon}`"></i>
                  Add Units
                </a>
                <a href="#" class="col-12 col-lg-4 p-5 btn btn-primary fw-bolder fs-5"
                  :class="$store.state.projectUUID == '9c54439ca9c54d1091ba9476fdb6d6f0' ? 'col-12 col-lg-4' : 'col'"
                  @click="setModalConfigs('create')"><i class="me-2 fs-4"
                    :class="`${contents.data.page.setting.buttonIcon}`"></i>
                  {{ contents.data.page.locale.buttonLabel }}
                </a>
              </div>
              <!--end::Action-->
            </div>
            <!--end::Wrapper-->
            <!--begin::Wrapper-->
            <div class="flex-equal d-flex align-self-center justify-content-end align-items-center order-0 order-md-1">
              <!--begin::Illustration-->
              <img :src="`${backendHost}/images/themes/${contentTheme}/${$store.state.sidebar[contents.name].routeImage
                }`" alt="" class="mw-100 min-h-100px mh-md-125px mh-lg-225pxs" />
              <!--end::Illustration-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Hero content-->
        </div>
        <!--end::Hero body-->
      </div>
      <div v-if="$store.state.projectUUID == '9c54439ca9c54d1091ba9476fdb6d6f0'" class="row gap-1 mb-12 px-4">
        <button class="col-2 btn btn-sm" :class="tabName == 'lessons' ? 'btn-primary' : 'btn-secondary'"
          @click="changeHafezliTab('lessons')">
          Lessons
        </button>
        <button class="col-2 btn btn-sm" :class="tabName == 'units' ? 'btn-primary' : 'btn-secondary'"
          @click="changeHafezliTab('units')">
          Units
        </button>
        <button class="col-2 btn btn-sm" :class="tabName == 'products' ? 'btn-primary' : 'btn-secondary'"
          @click="changeHafezliTab('products')">
          Products
        </button>
      </div>
      <div v-if="tabName == 'products'">
        <!--end::Hero card-->
        <div v-if="dataIsEmpty" class="card-body p-20">
          <div class="d-flex flex-center">
            <img class="col-md-3" :src="`/assets/images/svg/no_data.svg`" alt="" />
          </div>
        </div>
        <!--begin::Row-->
        <div v-else>
          <!--begin::Col-->
          <div v-if="pac" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">
            <div v-for="(product, index) in products" :key="index" class="col d-flex align-items-stretch">
              <!--begin::Card-->
              <div class="card w-100">
                <!--begin::Card body-->
                <div class="card-body pb-0 d-flex flex-column">
                  <div class="mb-6">
                    <a href="#"
                      class="text-inverse-light bg-light text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8">{{
                        product.categoryName }}</a>
                  </div>
                  <!--begin::Image-->
                  <div class="d-flex justify-content-center mb-5">
                    <div :id="`carouselExampleIndicators${index}`" class="carousel slide" data-bs-ride="carousel">
                      <div class="carousel-indicators color-dark">
                        <button v-for="(photo, bid) in product.productPhotos" :key="bid" type="button"
                          :data-bs-target="`#carouselExampleIndicators${index}`" :data-bs-slide-to="`${bid}`"
                          :class="bid == 0 ? `active` : ''" :aria-current="bid == 0 ? true : null"
                          :aria-label="`Slide ${Number(bid) + 1}`"></button>
                      </div>
                      <div class="carousel-inner aspect_ratio_square">
                        <div v-for="(photo, pid) in product.productPhotos" :key="photo"
                          :class="pid == 0 ? 'active' : ''">
                          <div class="symbol symbol-200px" style="background-color: #cccc">
                            <!-- {{ photo }} -->
                            <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                              class="d-block card-image img w-325px" :alt="`${photo}`" />
                          </div>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <!--end::Image-->
                  <!--begin::Title-->
                  <a :href="`${backendHost}/shop/r/${product.id}?locale=${routeLocale}`"
                    class="fs-4 text-gray-800 text-hover-primary fw-bold mb-1" target="_blank">{{ product.productName
                    }} {{ product }}</a>
                  <!--begin::Summary-->
                  <div class="text-gray-500 mb-3 text_justify fs-7">
                    {{ product.productSummary }}
                  </div>
                  <!--end::Summary-->
                  <!--end::Title-->
                  <!--begin::Position-->
                  <div class="d-flex flex-stack mb-3">
                    <div class="text-gray-500">
                      <i class="bi bi-star-fill text-warning me-1"> </i>
                      <span class="fs-8">{{ product.productRate }}</span>
                    </div>
                    <div class="text-gray-500">
                      <i class="bi bi-people me-1"></i>
                      {{ product.productStudents }}
                    </div>
                  </div>
                  <div class="d-flex flex-stack mb-3">
                    <div class="text-gray-500">
                      <i class="bi bi-clock me-1"> </i>
                      {{ product.productDuration }}
                    </div>
                    <div class="text-gray-500">
                      <i class="bi bi-book me-1"> </i>
                      {{ product.productSessionsNo }}
                    </div>
                  </div>
                  <!--end::Position-->
                </div>
                <div class="card-footer py-3 d-flex flex-column">
                  <div class="d-flex flex-stack mb-5">
                    <a href="" class="symbol symbol-circle symbol-30px text-dark text-hover-primary fs-8">
                      <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${product.profilePhoto}`"
                        class="me-1" :alt="`${product.userUserName} photo`" />
                      <span class="ms-1">{{ product.profileFullName }}</span>
                    </a>
                    <div class="d-flex flex-column">
                      <!-- <span class="text-danger"><del> 596,000 تومان</del></span> -->
                      <span v-if="product.productPrice == 0" class="text-success">Feel Free</span>
                      <span v-else class="text-success">{{ product.productPrice }}
                        {{ product.productCurrency }}</span>
                    </div>
                  </div>
                  <div class="align-self-center">
                    <!-- <a
                      :href="`/role-view?id=${product.id}`"
                      class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                      >{{ contents.data.page.card.buttons[0].label }}</a
                    > -->
                    <!-- <button
                      type="button"
                      class="btn btn-sm btn-light btn-active-light-primary my-1 me-2"
                      @click="setModalConfigs('update', index)"
                    >
                      {{ contents.data.page.card.buttons[1].label }}
                    </button> -->
                    <!-- <button
                      type="button"
                      class="btn btn-sm btn-light btn-active-light-danger my-1"
                      data-bs-toggle="modal"
                      data-bs-target="#kt_modal_update_role"
                      @click="setModalConfigs('delete', index)"
                    >
                      {{ contents.data.page.card.buttons[2].label }}
                    </button> -->
                  </div>
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card-->
            </div>
          </div>
          <div v-else class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">
            <div v-for="(product, index) in products" :key="index" class="col d-flex align-items-stretch">
              <!--begin::Card-->
              <div class="card w-100">
                <!--begin::Card body-->
                <div class="card-body pb-0 d-flex flex-column">
                  <div class="mb-6 d-flex flex-stack">
                    <a href="#"
                      class="text-primary bg-light-primary text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8 me-2">{{
                        product.categoryName }}</a>
                    <div class="d-flex gap-2">
                      <a v-for="tag in product.productTagsName" :key="tag.id" :href="`#${tag.id}`"
                        class="text-inverse-light bg-light text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8">{{
                          tag.tagName }}</a>
                    </div>
                  </div>
                  <!--begin::Image-->
                  <div class="d-flex justify-content-center mb-5">
                    <div :id="`carouselExampleIndicators${index}`" class="carousel slide" data-bs-ride="carousel">
                      <div class="carousel-indicators">
                        <button v-for="(photo, bid) in product.productPhotos" :key="bid" type="button"
                          :data-bs-target="`#carouselExampleIndicators${index}`" :data-bs-slide-to="`${bid}`"
                          :class="bid == 0 ? `active` : ''" :aria-current="bid == 0 ? true : null"
                          :aria-label="`Slide ${Number(bid) + 1}`"></button>
                      </div>
                      <div class="carousel-inner">
                        <div v-for="(photo, pid) in product.productPhotos" :key="photo" class="carousel-item"
                          :class="pid == 0 ? 'active' : ''">
                          <div class="symbol symbol-200px aspect_ratio_square" style="background-color: #cccc">
                            <img v-if="
                              photo.length > 1 &&
                              photo.split('.') &&
                              photo.split('.').length > 1 &&
                              ['png', 'jpg', 'jpeg', 'webp'].indexOf(
                                photo.split('.')[1].toLowerCase()
                              ) != -1
                            " :src="`${backendHost}/uploads/${$store.state.uploadsPath
                              }/${encodeURIComponent(photo)}`" class="d-block card-image img mw-200px"
                              :alt="`${photo} ${encodeURIComponent(photo)}`" />
                            <video v-else-if="
                              ['mp4', 'avi'].indexOf(photo.split('.')[1]) != -1
                            " :src="`${backendHost}/uploads/${$store.state.uploadsPath
                              }/${encodeURIComponent(photo)}`" class="d-block card-image img mw-200px"></video>
                          </div>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <!--end::Image-->
                  <!--begin::Title-->
                  <a :href="`${backendHost}/shop/r/${product.id}?locale=${routeLocale}`"
                    class="fs-4 text-gray-800 text-hover-primary fw-bold mb-1" target="_blank">{{ product.productName
                    }}</a>
                  <!--begin::Summary-->
                  <div class="text-gray-500 mb-3 text_justify fs-7">
                    {{ product.productSummary }}
                  </div>
                  <!--end::Summary-->
                  <!--end::Title-->
                  <!--begin::Position-->
                  <div class="d-flex flex-stack mb-3">
                    <div class="text-gray-500">
                      <i class="bi bi-calendar me-1"> </i>
                      {{ product.productDate }}
                    </div>
                    <div class="text-gray-500">
                      <i class="bi bi-star-fill text-warning me-1"> </i>
                      <span class="fs-8">{{ product.productRate }}</span>
                    </div>
                  </div>
                  <!--end::Position-->
                </div>
                <div class="card-footer py-3 d-flex flex-column">
                  <div class="d-flex flex-stack mb-5">
                    <a href="" class="symbol symbol-circle symbol-30px text-dark text-hover-primary fs-8">
                      <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${product.profilePhoto}`"
                        class="me-1" :alt="`${product.userUserName} photo`" />
                      <span class="ms-1">{{ product.profileFullName }}</span>
                    </a>
                    <div class="d-flex flex-column text-end">
                      <!-- <span class="text-danger"><del> 596,000 تومان</del></span> -->
                      <span v-if="product.productPrice == 0" class="text-success">Free</span>
                      <div v-else class="d-flex flex-column">
                        <div v-if="product.productOff > 0">
                          <span class="text-danger"><del>{{ product.productPrice }}
                              {{ product.productCurrency }}</del></span>
                          <span class="text-success">{{ product.productPrice }}
                            {{ product.productCurrency }}</span>
                        </div>
                        <div v-else>
                          <span class="text-success">{{ product.productPrice }}
                            {{ product.productCurrency }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="align-self-center">
                    <!-- <a
                      :href="`/${routeLocale}/productview/${product.id}`"
                      class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                      >{{ contents.data.page.card.buttons[0].label }}</a
                    > -->
                    <button type="button" class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                      @click="setModalConfigs('view', product)">
                      {{ contents.data.page.card.buttons[0].label }}
                    </button>
                    <button type="button" class="btn btn-sm btn-light btn-active-light-primary my-1 me-2"
                      @click="setModalConfigs('update', index)">
                      {{ contents.data.page.card.buttons[1].label }}
                    </button>
                    <button type="button" class="btn btn-sm btn-light btn-active-light-danger my-1"
                      data-bs-toggle="modal" data-bs-target="#kt_modal_update_role"
                      @click="setModalConfigs('delete', index)">
                      {{ contents.data.page.card.buttons[2].label }}
                    </button>
                  </div>
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card-->
            </div>
          </div>
          <div v-if="totalPages > 1" class="w-100 text-center mt-5">
            <pagination :pages="totalPages" v-model="currentPage" @update:modelValue="setCurrentPage"></pagination>
          </div>
          <!--end::Col-->
        </div>
      </div>
      <div v-if="tabName == 'units'">
        <div v-if="hafezliUnits.length == 0" class="card-body p-20">
          <div class="d-flex flex-center">
            <img class="col-md-3" :src="`/assets/images/svg/no_data.svg`" alt="" />
          </div>
        </div>
        <div v-else class="card card-body pt-0">
          <!--begin::Table-->
          <div class="d-flex flex-column scroll-y me-n7 pe-7">
            <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_user">
              <!--begin::Table head-->
              <thead>
                <!--begin::Table row-->
                <tr class="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                  <!-- <th class="w-10px pe-2">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid me-3"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      data-kt-check="true"
                      data-kt-check-target="#kt_table_users .form-check-input"
                      value="1"
                    />
                  </div>
                </th> -->
                  <th v-for="(header, index) in hafezliTableHeaders" :key="index" :class="header.class">
                    {{ header.title }}
                  </th>
                </tr>
                <!--end::Table row-->
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="text-gray-600 fw-bold">
                <!--begin::Table row-->
                <tr v-for="(lesson, index) in hafezliUnits" :key="index">
                  <td>{{ lesson.formName }}</td>
                  <td>
                    {{ lesson.formDescription }}
                  </td>
                  <!--begin::Action=-->
                  <td>
                    <div class="d-flex justify-content-end flex-shrink-0">
                      <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                        @click="setModalConfigs('hliUnitUpdate', index)">
                        <!--begin::Svg Icon | path: icons/duotune/art/art005.svg-->
                        <span class="svg-icon svg-icon-3">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3"
                              d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                              fill="currentColor"></path>
                            <path
                              d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                              fill="currentColor"></path>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->
                      </a>
                      <a href="#" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        @click="setModalConfigs('hliUnitDelete', index)">
                        <!--begin::Svg Icon | path: icons/duotune/general/gen027.svg-->
                        <span class="svg-icon svg-icon-3">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                              fill="currentColor"></path>
                            <path opacity="0.5"
                              d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                              fill="currentColor"></path>
                            <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                              fill="currentColor"></path>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->
                      </a>
                    </div>
                  </td>
                  <!--end::Action=-->
                </tr>
                <!--end::Table row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <div v-if="totalPages > 1" class="w-100 text-center mt-5">
            <pagination :pages="totalPages" v-model="currentPage" @update:modelValue="setCurrentPage"></pagination>
          </div>
          <!--end::Table-->
        </div>
      </div>
      <div v-if="tabName == 'lessons'">
        <div v-if="hafezliLessons.length == 0" class="card-body p-20">
          <div class="d-flex flex-center">
            <img class="col-md-3" :src="`/assets/images/svg/no_data.svg`" alt="" />
          </div>
        </div>
        <div v-else class="card card-body pt-0">
          <!--begin::Table-->
          <div class="d-flex flex-column scroll-y me-n7 pe-7">
            <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_user">
              <!--begin::Table head-->
              <thead>
                <!--begin::Table row-->
                <tr class="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                  <!-- <th class="w-10px pe-2">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid me-3"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      data-kt-check="true"
                      data-kt-check-target="#kt_table_users .form-check-input"
                      value="1"
                    />
                  </div>
                </th> -->
                  <th v-for="(header, index) in hafezliTableHeaders" :key="index" :class="header.class">
                    {{ header.title }}
                  </th>
                </tr>
                <!--end::Table row-->
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="text-gray-600 fw-bold">
                <!--begin::Table row-->
                <tr v-for="(lesson, index) in hafezliLessons" :key="index">
                  <td>{{ lesson.formName }}</td>
                  <td class="mw-200px">
                    {{ lesson.formDescription }}
                  </td>
                  <!--begin::Action=-->
                  <td>
                    <div class="d-flex justify-content-end flex-shrink-0">
                      <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                        @click="setModalConfigs('hliLessonUpdate', index)">
                        <!--begin::Svg Icon | path: icons/duotune/art/art005.svg-->
                        <span class="svg-icon svg-icon-3">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3"
                              d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                              fill="currentColor"></path>
                            <path
                              d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                              fill="currentColor"></path>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->
                      </a>
                      <a href="#" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        @click="setModalConfigs('hliLessonDelete', index)">
                        <!--begin::Svg Icon | path: icons/duotune/general/gen027.svg-->
                        <span class="svg-icon svg-icon-3">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                              fill="currentColor"></path>
                            <path opacity="0.5"
                              d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                              fill="currentColor"></path>
                            <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                              fill="currentColor"></path>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->
                      </a>
                    </div>
                  </td>
                  <!--end::Action=-->
                </tr>
                <!--end::Table row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <div v-if="totalPages > 1" class="w-100 text-center mt-5">
            <pagination :pages="totalPages" v-model="currentPage" @update:modelValue="setCurrentPage"></pagination>
          </div>
          <!--end::Table-->
        </div>
      </div>
      <!--end::Row-->
      <!--begin::Modals-->
      <create-update v-if="modalDisplay" :stepType="stepType" :contents="contents.data.modal" :modalInfo="productInfo"
        :mode="mode" :modalType="'uploadselect'" :firstErrorName="firstErrorName" :hafezliUnits="hafezliUnits"
        @close-modal="setModalConfigs"></create-update>
      <hafezli-units v-if="huModalDisplay" :contents="contents.data.modal" :modalInfo="productInfo" :mode="mode"
        :items="hafezliLessons" :modalType="'uploadselect'" :firstErrorName="firstErrorName"
        @close-modal="setModalConfigs"></hafezli-units>
      <hafezli-lessons v-if="hpModalDisplay" :stepType="stepType" :contents="contents.data.modal"
        :modalInfo="productInfo" :mode="mode" :modalType="'uploadselect'" :firstErrorName="firstErrorName"
        @close-modal="setModalConfigs"></hafezli-lessons>
      <dialog-box v-if="dialogDisplay" :contents="contents.data.modal" :modalInfo="deleteInfo"
        @close-modal="setModalConfigs">
      </dialog-box>
      <!--end::Modals-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import dataService from "../../../services/data";
import serverConfigs from "../../../configs/server.json";

// Tools
import Pagination from "../../tools/Pagination.vue";

// Modals
import CreateUpdate from "../../modals/CreateUpdate.vue";
import DialogBox from "../../modals/DialogBox.vue";
import HafezliLessons from "../../modals/HafezliLessons.vue";
import HafezliUnits from "../../modals/HafezliUnits.vue";

export default {
  components: {
    Pagination,
    CreateUpdate,
    DialogBox,
    HafezliLessons,
    HafezliUnits
  },
  setup() { },
  computed: {
    contentTheme() {
      return this.$store.state.themeFile.replace(".css", "");
    },
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    routeLocale() {
      return this.$route.params.locale;
    },
    bodyNode() {
      return document.getElementById("kt_body");
    },
  },
  data() {
    return {
      hafezliUnitsParent: 6133,
      hafezliLessonsParent: 6096,
      tabName: "products",
      hafezliLessons: [],
      hafezliUnits: [],
      hafezliTableHeaders: [
        {
          title: "Title",
          class: "min-w-125px",
        },
        {
          title: "Summary",
          class: "mw-200px",
        },
        {
          title: "Activity",
          class: "w-100px text-end",
        },
      ],
      hpModalDisplay: false,
      huModalDisplay: false,
      totalPages: 0,
      currentPage: 1,
      pac: false,
      productInfo: {},
      deleteInfo: Object,
      modalDisplay: false,
      dialogDisplay: false,
      dataIsEmpty: true,
      products: [],
      firstErrorName: "",
      contents: {
        name: "",
        data: {},
        status: false,
      },
      mode: "multi",
      stepType: null,
      loaderStatus: [false, false],
    };
  },
  methods: {
    setModalConfigs(opt, index) {
      this.$store.commit("setLoader", true);

      switch (opt) {
        case "update":
          this.productInfo = { ...this.products[index], status: false };
          this.productInfo["photos"] = this.products[index].productPhotos;
          this.modalDisplay = !this.modalDisplay;

          this.$store.commit("setLoader", false);

          break;
        case "create":
          this.setupProductInfo();
          this.modalDisplay = !this.modalDisplay;
          this.$store.commit("setLoader", false);

          break;
        case "delete":
          this.deleteInfo = {
            id: this.products[index].id,
            name: this.products[index].productName,
            status: true,
            delete: true,
          };
          this.dialogDisplay = !this.dialogDisplay;
          this.$store.commit("setLoader", false);

          break;
        case "validate":
          if (index.delete) {
            this.deleteProducts(index);
          } else {
            console.log(index.id);
            // index["productPhotos"] = index["photos"];
            // if (this.inputValidation(index)) {
            index.id ? this.updateProducts(index) : this.createProducts(index);
            // } else {
            //   this.$store.commit("setLoader", false);
            // }
          }
          break;
        case "view":
          this.$store.commit("setCurProduct", index);

          this.$store.commit("setLoader", false);

          this.$router.push(`productview/${index.id}`);
          break;
        case "hliUnits":
          this.setupProductInfo();
          this.huModalDisplay = true;
          this.$store.commit("setLoader", false);

          break;
        case "hliUnitsValidate":
          console.log(index)
          index.id ? this.updateHafezliUnits(index) : this.createHafezliUnits(index)
          this.huModalDisplay = false;
          this.$store.commit("setLoader", false);
          break;
        case "hliUnitUpdate":
          this.productInfo = {
            id: this.hafezliUnits[index].id,
            title: this.hafezliUnits[index].formName,
            description: this.hafezliUnits[index].formDescription,
            lessons: this.hafezliUnits[index].formJson.lessons
          }

          this.huModalDisplay = true;
          this.$store.commit("setLoader", false);
          break;
        case "hliLessons":
          this.setupProductInfo();
          this.hpModalDisplay = true;
          this.$store.commit("setLoader", false);

          break;
        case "hliLessonsValidate":
          index[0].id ? this.updateHafezliLessons(index) : this.createHafezliLessons(index)
          this.hpModalDisplay = false;
          this.$store.commit("setLoader", false);
          break;
        case "hliLessonUpdate":
          this.productInfo = [{
            id: this.hafezliLessons[index].id,
            title: this.hafezliLessons[index].formName,
            summary: this.hafezliLessons[index].formDescription
          }]
          for (let i in this.hafezliLessons[index].formJson) {
            this.productInfo.push(this.hafezliLessons[index].formJson[i])
          }

          this.hpModalDisplay = true;
          this.$store.commit("setLoader", false);
          break;
        default:
          this.resetProductInfo();
          this.huModalDisplay = false;
          this.hpModalDisplay = false;
          this.$store.commit("setLoader", false);

          break;
      }
    },
    changeHafezliTab(index) {
      this.tabName = index
    },
    createHafezliUnits(obj) {
      let data = {
        endPoint: `forms`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          parent: this.hafezliUnitsParent,
          name: obj['title'],
          category: 355,
          tags: [],
          template: 316,
          json: {
            'lessons': obj.lessons
          },
          description: obj['description']
        },
      };

      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your unit has been saved successfully!"
            // text: res.data.message,
          });
          this.getHafezliLessons()
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    updateHafezliUnits(obj) {
      let tempJson = []
      for (let i = 1; i < obj.length; i++) {
        tempJson.push(obj[i])
      }
      let data = {
        endPoint: `forms/u/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          name: obj['title'],
          json: {
            'lessons': obj.lessons
          },
          description: obj['description']
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your unit has been updated successfully!"
            // text: res.data.message,
          });
          this.getHafezliUnits()
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    getHafezliUnits() {
      let data = {
        endPoint: `forms`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          parent: `${this.hafezliUnitsParent}`,
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");

      dataService
        .get(data)
        .then((res) => {
          this.hafezliUnits = res.data.data
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    createHafezliLessons(obj) {
      console.log(obj)
      let tempJson = []
      for (let i = 1; i < obj.length; i++) {
        tempJson.push(obj[i])
      }
      let data = {
        endPoint: `forms`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          parent: this.hafezliLessonsParent,
          name: obj[0]['title'],
          category: 355,
          tags: [],
          template: 316,
          json: tempJson,
          description: obj[0]['summary']
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your lesson has been saved successfully!"
            // text: res.data.message,
          });
          this.getHafezliLessons()
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    updateHafezliLessons(obj) {
      let tempJson = []
      for (let i = 1; i < obj.length; i++) {
        tempJson.push(obj[i])
      }
      let data = {
        endPoint: `forms/u/${obj[0].id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          name: obj[0]['title'],
          json: tempJson,
          description: obj[0]['summary']
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your lesson has been updated successfully!"
            // text: res.data.message,
          });
          this.getHafezliLessons()
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    getHafezliLessons() {
      let data = {
        endPoint: `forms`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          parent: `${this.hafezliLessonsParent}`,
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");

      dataService
        .get(data)
        .then((res) => {
          this.hafezliLessons = res.data.data
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    setCurrentPage(page) {
      this.$store.commit("setLoader", true);
      this.readProducts(page);
    },
    loaderDone() {
      if (
        this.loaderStatus[0] &&
        this.loaderStatus[1] &&
        this.loaderStatus[2]
      ) {
        this.$store.commit("setLoader", false);
      }
    },
    getContents() {
      let data = {
        endPoint: `contents/r/products`,
        locale: `${this.routeLocale}`,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          this.contents = {
            name: res.data.data[0].contentName,
            data: res.data.data[0].contentJson,
            status: true,
          };

          this.contents.data.modal.fields = this.$store.state.shopType.includes(
            "->"
          )
            ? this.contents.data.modal.fields[
            this.$store.state.shopType.split("->")[0]
            ][this.$store.state.shopType.split("->")[1]]
            : this.contents.data.modal.fields[this.$store.state.shopType];
          // if (this.$store.state.shopType.split("->")[1] == "hafezli") {
          //   this.stepType = "wizard";
          // }
          this.readCategories();
          this.readTags();
          if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
            this.readTemplates();
          }
          // this.setupOptions();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[0] = true;
          this.loaderDone();
        });
    },
    setupProductInfo() {
      let rootCard = {};
      let childCard = {};
      for (let counter in this.contents.data.modal.fields) {
        switch (this.contents.data.modal.fields[counter].type) {
          case "text":
            this.productInfo[this.contents.data.modal.fields[counter].name] =
              "";
            break;
          case "textarea":
            this.productInfo[this.contents.data.modal.fields[counter].name] =
              "";
            break;
          case "card":
            Object.assign(
              rootCard,
              this.contents.data.modal.fields[counter].value
            );
            this.productInfo[this.contents.data.modal.fields[counter].name] = [
              rootCard,
            ];
            for (let i in this.contents.data.modal.fields[counter].fields) {
              switch (this.contents.data.modal.fields[counter].fields[i].type) {
                case "text":
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = "";
                  break;
                case "textarea":
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = "";
                  break;
                case "card":
                  Object.assign(
                    childCard,
                    this.contents.data.modal.fields[counter].fields[i].value
                  );
                  this.productInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = [childCard];
                  break;
                default:
                  break;
              }
            }
            break;
          default:
            break;
        }
      }
      this.productInfo["status"] = true;
    },
    setupOptions() {
      for (let field in this.contents.data.modal.fields) {
        if (this.contents.data.modal.fields[field].type == "dbcombobox") {
          let data = {
            endPoint: this.contents.data.modal.fields[field].rel,
            locale: `${this.routeLocale}`,
            data: {},
            token: this.$store.state.token,
            uuid: this.$store.state.projectUUID,
            query: this.contents.data.modal.fields[field].query
          };

          dataService
            .get(data)
            .then((res) => {
              for (let option in res.data.data) {
                this.contents.data.modal.fields[field].options.push({
                  title: res.data.data[option][this.contents.data.modal.fields[field].optionName],
                  value: res.data.data[option][this.contents.data.modal.fields[field].optionValue],
                });
              }
              this.contents.data.modal.fields[field].type = "combobox"
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    resetProductInfo() {
      this.productInfo = {};
      this.modalDisplay = false;
      this.dialogDisplay = false;
      if (!this.modalDisplay) {
        this.bodyNode.classList.remove("modal-open");
        this.bodyNode.style.overflow = "visible";
      }
      for (let index in this.contents.data.modal.fields) {
        if (this.contents.data.modal.fields[index].required) {
          this.contents.data.modal.fields[index].errorCode = 0;
        }
      }
    },
    inputValidation(obj) {
      let errorCount = 0;
      let tempError = "";

      for (
        let index = 0;
        index < this.contents.data.modal.fields.length;
        index++
      ) {
        // if (this.contents.data.modal.fields[index].type == "card") {
        //   for (
        //     let i = 0;
        //     i < this.contents.data.modal.fields[index].fields.length;
        //     i++
        //   ) {
        //     for (let p in obj[this.contents.data.modal.fields[index].name]) {
        //       if (
        //         this.contents.data.modal.fields[index].fields[i].type == "card"
        //       ) {
        //         for (
        //           let j = 0;
        //           j <
        //           this.contents.data.modal.fields[index].fields[i].fields
        //             .length;
        //           j++
        //         ) {
        //           if (
        //             this.contents.data.modal.fields[index].fields[i].fields[j]
        //               .required
        //           ) {
        //             console.log(obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i].name
        //                   ])
        //                   console.log(this.contents.data.modal.fields[index].fields[i].name)
        //             // for (let s in obj[
        //             //   this.contents.data.modal.fields[index].fields[i].name
        //             // ]) {
        //             //   // for (let expression in this.contents.data.modal.fields[
        //             //   //   index
        //             //   // ].fields[i].fields[j].validation) {
        //             //   //   switch (
        //             //   //     this.contents.data.modal.fields[index].fields[i]
        //             //   //       .fields[j].validation[expression].expression
        //             //   //   ) {
        //             //   //     case "isEmpty":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].fields[j].errorCode =
        //             //   //         !obj[this.contents.data.modal.fields[index].name][
        //             //   //           p
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ][s] ||
        //             //   //         obj[this.contents.data.modal.fields[index].name][
        //             //   //           s
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ].length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     case "isSpace":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].errorCode =
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .validation.length > 1 &&
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].errorCode
        //             //   //           : String(
        //             //   //               obj[
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .name
        //             //   //               ][p][
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .fields[i].name
        //             //   //               ]
        //             //   //             ).trim().length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     default:
        //             //   //       this.contents.data.modal.fields[
        //             //   //         index
        //             //   //       ].errorCode = 0;
        //             //   //       break;
        //             //   //   }
        //             //   // }
        //             // }
        //           }
        //         }
        //       } else {
        //         if (this.contents.data.modal.fields[index].fields[i].required) {
        //           for (let expression in this.contents.data.modal.fields[index]
        //             .fields[i].validation) {
        //             switch (
        //               this.contents.data.modal.fields[index].fields[i]
        //                 .validation[expression].expression
        //             ) {
        //               case "isEmpty":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   !obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ] ||
        //                   obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ].length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               case "isSpace":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .validation.length > 1 &&
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .errorCode
        //                     : String(
        //                         obj[
        //                           this.contents.data.modal.fields[index].name
        //                         ][p][
        //                           this.contents.data.modal.fields[index].fields[
        //                             i
        //                           ].name
        //                         ]
        //                       ).trim().length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               default:
        //                 this.contents.data.modal.fields[index].errorCode = 0;
        //                 break;
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }
        // } else {
        if (this.contents.data.modal.fields[index].required) {
          for (let expression in this.contents.data.modal.fields[index]
            .validation) {
            switch (
            this.contents.data.modal.fields[index].validation[expression]
              .expression
            ) {
              case "isEmpty":
                this.contents.data.modal.fields[index].errorCode =
                  !obj[this.contents.data.modal.fields[index].name] ||
                    obj[this.contents.data.modal.fields[index].name].length == 0
                    ? this.contents.data.modal.fields[index].validation[
                      expression
                    ].id
                    : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              case "isSpace":
                this.contents.data.modal.fields[index].errorCode =
                  this.contents.data.modal.fields[index].validation.length >
                    1 && this.contents.data.modal.fields[index].errorCode > 0
                    ? this.contents.data.modal.fields[index].errorCode
                    : String(
                      obj[this.contents.data.modal.fields[index].name]
                    ).trim().length == 0
                      ? this.contents.data.modal.fields[index].validation[
                        expression
                      ].id
                      : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              default:
                this.contents.data.modal.fields[index].errorCode = 0;
                break;
            }
          }
        }
        // }
      }
      this.firstErrorName =
        tempError.length > 0 ? tempError : this.firstErrorName;
      return errorCount == 0 ? true : false;
    },
    inputValidation_new(obj) {
      let errorCount = 0;
      let tempItem = {};

      let tempStep = this.contents.data.modal.fields;
      for (let i in tempStep) {
        if (
          tempStep[i].type == "tab" ||
          tempStep[i].type == "radioTab" ||
          tempStep[i].type == "imgRadio" ||
          tempStep[i].type == "mulImgRadio"
        ) {
          tempItem = tempStep[i].tabs[this.registerInfo[tempStep[i].key]].rows;
        } else {
          tempItem = tempStep;
        }
      }
      for (let i in tempItem) {
        if (tempItem[i].required) {
          for (let v in tempItem[i].validation) {
            switch (tempItem[i].validation[v].expression) {
              case "isEmpty":
                tempItem[i].errorCode =
                  !obj[tempItem[i].key] || obj[tempItem[i].key].length == 0
                    ? tempItem[i].validation[v].id
                    : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                tempItem[i].type == "selectMiniFile"
                  ? null
                  : this.goto(tempItem[i].name);
                break;
              case "isSpace":
                tempItem[i].errorCode =
                  tempItem[i].validation.length > 1 && tempItem[i].errorCode > 0
                    ? tempItem[i].errorCode
                    : String(obj[tempItem[i].name]).trim().length == 0
                      ? tempItem[i].validation[v].id
                      : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                this.goto(tempItem[i].name);
                break;
              default:
                tempItem[i].errorCode = 0;
                break;
            }
          }
        }
      }
      return errorCount == 0 ? true : false;
    },
    createProducts(obj) {
      console.log(obj);
      console.log(this.stepType)
      if (this.stepType == "wizard") {
        let generalInfo = obj.info[0]
        let chaptersInfo = obj.info.slice(1)
        let data = {
          endPoint: `products`,
          locale: `${this.routeLocale}`,
          token: this.$store.state.token,
          uuid: this.$store.state.projectUUID,
          data: {
            name: generalInfo["title"],
            summary: generalInfo["summary"],
            price: generalInfo["price"],
            photos: generalInfo["files"],
            category: generalInfo["category"],
            tags: generalInfo["tags"],
            chapters: chaptersInfo,
            locale: `${this.routeLocale}`,
            review: generalInfo["description"],
            user: generalInfo["teacher"]
          },
        };
        dataService
          .post(data)
          .then((res) => {
            this.$notify({
              type: res.data.type,
              title: res.data.type,
              text: res.data.message,
            });
            this.$store.commit("setLoader", true);
            this.resetProductInfo();
            this.readProducts(0);
          })
          .catch((error) => {
            this.$notify({
              type: error.response.data.type,
              title: error.response.data.type,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            this.$store.commit("setLoader", false);
          });
      } else {
        if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
          obj["productChapters"] = {
            id: obj["productChapters"]
          }
        }
        let data = {
          endPoint: `products`,
          locale: `${this.routeLocale}`,
          token: this.$store.state.token,
          uuid: this.$store.state.projectUUID,
          data: {
            name: obj["productName"],
            summary: obj["productSummary"],
            price: obj["productPrice"],
            photos: obj["productPhotos"],
            category: obj["productCategory"],
            tags: obj["productTags"],
            chapters: obj["productChapters"],
            review: obj["productReview"],
          },
        };
        dataService
          .post(data)
          .then((res) => {
            this.$notify({
              type: res.data.type,
              title: res.data.type,
              text: res.data.message,
            });
            this.resetProductInfo();
            this.readProducts();
          })
          .catch((error) => {
            this.$notify({
              type: error.response.data.type,
              title: error.response.data.type,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            this.$store.commit("setLoader", false);
          });
      }
    },
    readProducts(page) {
      let data = {
        endPoint: `products`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          console.log(res.data);
          res.data.data.length > 0
            ? (this.dataIsEmpty = false)
            : (this.dataIsEmpty = true);
          this.products = res.data.data;
          this.products = this.products.reverse();
          for (let i in this.products) {
            this.products[i].productDate = new Date(
              this.products[i].productDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });

            if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
              this.products[i].productChapters = this.products[i].productChapters['id']
            }
          }
          if (page == 1) {
            this.totalPages = res.data.totalRes;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[1] = true;
          this.loaderDone();
        });
    },
    readCategories() {
      let data = {
        endPoint: `categories`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          category: "Shop",
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");

      dataService
        .get(data)
        .then((res) => {
          let tempCategories = {};
          this.contents.data.modal.fields.forEach((field) => {
            if (field.name == "productCategory") {
              tempCategories = field;
            }
          });
          for (let i in res.data.data) {
            tempCategories.options.push({
              title: res.data.data[i].categoryName,
              value: res.data.data[i].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readTags() {
      let data = {
        endPoint: `tags`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let tempTags = {};
          this.contents.data.modal.fields.forEach((field) => {
            if (field.name == "productTags") {
              tempTags = field;
            }
          });
          for (let tag in res.data.data) {
            tempTags.options.push({
              title: res.data.data[tag].tagName,
              value: res.data.data[tag].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readTemplates() {
      let data = {
        endPoint: `templates`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          category: "aeprojects",
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)
          let tempTags = {};
          this.contents.data.modal.fields.forEach((field) => {
            if (field.name == "productChapters") {
              tempTags = field;
            }
          });

          for (let tag in res.data.data) {
            tempTags.options.push({
              title: res.data.data[tag].templateName,
              value: res.data.data[tag].id,
            });
          }
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            type: error.response ? error.response.data.type : "error",
            title: error.response ? error.response.data.type : "Error",
            text: error.response ? error.response.data.message : error,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    updateProducts(obj) {
      console.log(obj);
      if (this.stepType == "wizard") {
        let generalInfo = obj.info[0]
        let chaptersInfo = obj.info.slice(1)
        let data = {
          endPoint: `products/u/${obj.id}`,
          locale: `${this.routeLocale}`,
          token: this.$store.state.token,
          uuid: this.$store.state.projectUUID,
          data: {
            name: generalInfo["title"],
            summary: generalInfo["summary"],
            price: generalInfo["price"],
            photos: generalInfo["files"],
            category: generalInfo["category"],
            tags: generalInfo["tags"],
            chapters: chaptersInfo,
            review: generalInfo["description"],
            user: generalInfo["teacher"]
          },
        };
        dataService
          .post(data)
          .then((res) => {
            this.$notify({
              type: res.data.type,
              title: res.data.type,
              text: res.data.message,
            });
            this.resetProductInfo();
            this.readProducts();
          })
          .catch((error) => {
            this.$notify({
              type: error.response.data.type,
              title: error.response.data.type,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            this.$store.commit("setLoader", false);
          });
      } else {
        if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
          obj["productChapters"] = {
            id: obj["productChapters"]
          }
        }
        let data = {
          endPoint: `products/u/${obj.id}`,
          locale: `${this.routeLocale}`,
          token: this.$store.state.token,
          uuid: this.$store.state.projectUUID,
          data: {
            name: obj["productName"],
            summary: obj["productSummary"],
            price: obj["productPrice"],
            photos: obj["productPhotos"],
            category: obj["productCategory"],
            tags: obj["productTags"],
            chapters: obj["productChapters"],
            review: obj["productReview"],
            status: obj["productStatus"],
          },
        };
        dataService
          .post(data)
          .then((res) => {
            this.$notify({
              type: res.data.type,
              title: res.data.type,
              text: res.data.message,
            });
            this.resetProductInfo();
            this.readProducts();
          })
          .catch((error) => {
            this.$notify({
              type: error.response.data.type,
              title: error.response.data.type,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            this.$store.commit("setLoader", false);
          });
      }
    },
    deleteProducts(obj) {
      this.$store.commit("setLoader", true);

      let data = {
        endPoint: `products/d/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetProductInfo();
          this.readProducts();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit("setLoader", false);
        });
    },
    goto() {
      // console.log(this.$refs[refName])
      // this.$refs[refName][0].scrollIntoView({ behavior: "smooth" });
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    this.getContents();
    this.readProducts(1);
    this.getHafezliLessons();
    this.getHafezliUnits();
  },
};
</script>

<style scoped>
.aspect_ratio_square {
  aspect-ratio: 1/1;
}

.aspect_ratio_169 {
  aspect-ratio: 16/9;
}

.aspect_ratio_916 {
  aspect-ratio: 9/16;
}

.aspect_ratio_43 {
  aspect-ratio: 4/3;
}

.aspect_ratio_34 {
  aspect-ratio: 3/4;
}
</style>
